import styled from 'styled-components';
import { getChipStyle } from 'tokens';
import type { UiColor } from 'tokens';

export const Base = styled.span<{ $color: UiColor }>`
	display: inline-flex;
	align-items: center;
	padding: 4px 12px;
	border-radius: 12px;
	font-size: 12px;
	font-weight: 600;
	line-height: 1;
	width: fit-content;
	background: ${(p) => getChipStyle(p.theme, p.$color).background};
	color: ${(p) => getChipStyle(p.theme, p.$color).color};
`;
